var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 300,
    viewBox: "0 0 280 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 279,
    height: 299,
    fill: "#EAEAEA",
    stroke: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35291 2.52101L77.647 83.1933",
    stroke: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202.353 216.807L277.647 297.479",
    stroke: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.353 83.1933L277.647 2.52101",
    stroke: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35291 297.479L77.647 216.807",
    stroke: "#C4C4C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124 142.6C124 140.612 125.693 139 127.78 139C129.868 139 131.561 140.612 131.561 142.6C131.561 144.588 129.868 146.2 127.78 146.2C125.693 146.2 124 144.588 124 142.6Z",
    fill: "#959595"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155 157H124.756V152.68L128.491 149.124C128.934 148.702 129.652 148.702 130.095 149.124L133.829 152.68L145.125 141.924C145.568 141.502 146.286 141.502 146.729 141.924L155 149.8V157Z",
    fill: "#959595"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.ba8fd1caf69f27bd1121cc178728ce03.svg";
export { ForwardRef as ReactComponent };